enum Error {
  SRC_PARSE = 'error-src-parse',
  MANIFEST_LOAD = 'error-manifest-load',
  MANIFEST_PARSE = 'error-manifest-parse',
  MANIFEST_INCOMPATIBLE = 'error-manifest-incompatible',
  LEVEL_LOAD = 'error-level-load',
  CONTENT_LOAD = 'error-content-load',
  CONTENT_PARSE = 'error-content-parse',
  MEDIA = 'error-media',
  UNKNOWN = 'error-unknown',
}

export default Error;
